<template>
  <v-col class="shrink app-sidebar">
    <div
      v-if="isSticky"
      :style="{ height: sidebarHeight + 'px' }"
    ></div>
    <div
      ref="stickySidebar"
      class="app-sidebar-right elevation-2"
      :class="{ 'app-sidebar-sticky': isSticky }"
      :style="stickyStyle"
    >
      <template v-if="!showBookNowForm">
        <BookingForm
          v-if="selectedObject && selectedObject._id"
          :object="selectedObject"
          :sidebar="true"
        />
        <div class="pb-1">
          <ContactUsMenu
            :sidebar="true"
            :contact-options="contactOptions"
          />
        </div>
      </template>
      <DynamicAutoHeightInfoBox
        v-if="showBookNowForm"
        :show-indexes="[1, 3]"
        :skip-auto-height="true"
      />
    </div>
    <div
      class="app-sidebar-right elevation-2"
      v-if="!showBookNowForm"
    >
      <div v-if="selectedObject && selectedObject._id">
        <CalendarLegend :show-legend-at-the-top="true" />
        <CalendarNavigation :show-overlay="!selectedObject.calendar" />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="1"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="2"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="3"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="4"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="5"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="6"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="7"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="
            isDesktopView && selectedObject.calendar && selectedObject.videoLink
          "
          :plus-months="8"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="
            isDesktopView && selectedObject.calendar && selectedObject.videoLink
          "
          :plus-months="9"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
      </div>
      <ContactBannerNew />
    </div>
  </v-col>
</template>

<script>
import BookingForm from '@/components/Forms/BookingForm'
import ContactUsMenu from '@/components/App/Menu/ContactUsMenu'
import CalendarLegend from '@/components/Calendar/CalendarLegend'
import CalendarNavigation from '@/components/Calendar/CalendarNavigation'
import sharedComputed from '@/methods/sharedComputed'
import sharedObjectComputed from '@/methods/sharedObjectComputed'
import state from '@/store/state'
import { createHelpers } from 'vuex-map-fields'
import DynamicAutoHeightInfoBox from '@/components/App/DynamicAutoHeightInfoBox'
import ContactBannerNew from '@/components/App/Extras/ContactBannerNew.vue'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ObjectRightSidebar',

  components: {
    ContactBannerNew,
    DynamicAutoHeightInfoBox,
    CalendarNavigation,
    CalendarLegend,
    ContactUsMenu,
    BookingForm,
  },

  data() {
    return {
      isSticky: false,
      sidebarInitialTop: 0,
      sidebarWidth: 0,
      sidebarHeight: 0,
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...sharedObjectComputed,

    stickyStyle() {
      if (this.isSticky) {
        return {
          position: 'fixed',
          top: '5px',
          width: this.sidebarWidth + 'px',
          background: 'white',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
          outline: '6px solid #219bc8',
          outlineOffset: '0px',
          zIndex: '1001',
        }
      }
      return {}
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.calculateSidebarDimensions()
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.handleResize)
      window.addEventListener('load', this.calculateSidebarDimensions)

      // Recalculate after a delay to ensure images are loaded
      setTimeout(() => {
        this.calculateSidebarDimensions()
      }, 500)
    })
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('load', this.calculateSidebarDimensions)
  },

  methods: {
    calculateSidebarDimensions() {
      if (this.$refs.stickySidebar && !this.isSticky) {
        const computedStyle = window.getComputedStyle(this.$refs.stickySidebar)
        const marginTop = parseFloat(computedStyle.marginTop)
        const marginBottom = parseFloat(computedStyle.marginBottom)

        this.sidebarWidth = this.$refs.stickySidebar.offsetWidth
        this.sidebarHeight = this.$refs.stickySidebar.offsetHeight + marginTop + marginBottom
        this.sidebarInitialTop = this.$refs.stickySidebar.offsetTop - marginTop
      }
    },

    handleScroll() {
      if (!this.$refs.stickySidebar) return

      const scrollTop = window.scrollY
      const threshold = this.sidebarInitialTop - 5 // 5px from top when sticky

      if (scrollTop >= threshold) {
        this.isSticky = true
      } else {
        this.isSticky = false
      }
    },

    handleResize() {
      this.calculateSidebarDimensions()
    },
  },
}
</script>

<style scoped>
</style>
